import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/quickAssignment';
import { getRouteIndex } from '../selectors/quickAssignment';

const initialState = fromJS({
  routes: [],
  assignmentsLoading: {},
  drags: {}
});

const setIsDragging = (state, {
  isDragging,
  routeId,
  type
}) => {
  if (isDragging)
    return state.setIn(['drags', routeId], fromJS({ [type]: true }));

  return state.removeIn(['drags', routeId, type]);
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.updateRoutesList: {
      const { routes, append = false } = action.payload;

      const updateRoutes = (routesList) => append ? routesList.concat(fromJS(routes)) : fromJS(routes);

      return state.updateIn(['routes'], updateRoutes);
    }
    case actions.assignDriver: {
      const { assignmentId, driver, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);
      const assignmentData = {
        id: assignmentId,
        driver
      };

      const driversList = state.getIn(['routes', routeIndex, 'route', 'driverAssignments'], fromJS([]));

      if (routeIndex > -1) {
        return state.setIn(
          ['routes', routeIndex, 'route', 'driverAssignments'],
          driversList.push(fromJS(assignmentData))
        );
      }

      return state;
    }
    case actions.unassignDriver: {
      const { assignmentId, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);

      return state.updateIn(
        ['routes', routeIndex, 'route', 'driverAssignments'],
        (driversList) => driversList.filter(item => item.get('id') !== assignmentId)
      );
    }
    case actions.assignHelper: {
      const { assignmentId, helper, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);
      const assignmentData = {
        id: assignmentId,
        helper
      };

      const helpersList = state.getIn(['routes', routeIndex, 'route', 'helperAssignments'], fromJS([]));

      if (routeIndex > -1) {
        return state.setIn(
          ['routes', routeIndex, 'route', 'helperAssignments'],
          helpersList.push(fromJS(assignmentData))
        );
      }

      return state;
    }
    case actions.unassignHelper: {
      const { assignmentId, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);

      return state.updateIn(
        ['routes', routeIndex, 'route', 'helperAssignments'],
        (helpersList) => helpersList.filter(item => item.get('id') !== assignmentId)
      );
    }
    case actions.assignEquipment: {
      const { assignmentId, equipment, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);
      const assignmentData = {
        id: assignmentId,
        equipment,
        principal: !!equipment.principal
      };

      const equipmentsList = state.getIn(['routes', routeIndex, 'route', 'equipmentAssignments'], fromJS([]));

      if (routeIndex > -1) {
        return state.setIn(
          ['routes', routeIndex, 'route', 'equipmentAssignments'],
          equipmentsList.push(fromJS(assignmentData))
        );
      }
      return state;
    }
    case actions.unassignEquipment: {
      const { assignmentId, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);

      return state.updateIn(
        ['routes', routeIndex, 'route', 'equipmentAssignments'],
        (equipmentsList) => equipmentsList.filter(item => item.get('id') !== assignmentId)
      );
    }
    case actions.updateEquipmentAssignments: {
      const { assignments, routeId } = action.payload;

      const routeIndex = getRouteIndex(state, routeId);

      if (routeIndex === -1) return state;

      return state.setIn(['routes', routeIndex, 'route', 'equipmentAssignments'], fromJS(assignments));
    }
    case actions.toggleAssignLoading: {
      const {
        routeId,
        key,
        text,
        triggerLoading = false
      } = action.payload;

      if (!triggerLoading || !text) {
        return state.setIn(['assignmentsLoading', routeId, key], null);
      }

      return state.setIn(['assignmentsLoading', routeId], fromJS({ [key]: text }));
    }
    case actions.isDraggingDriver: {
      const { routeId, isDragging } = action.payload;

      return setIsDragging(state, {
        isDragging,
        type: 'driver',
        routeId
      });
    }
    case actions.isDraggingHelper: {
      const { routeId, isDragging } = action.payload;

      return setIsDragging(state, {
        isDragging,
        type: 'helper',
        routeId
      });
    }
    case actions.isDraggingEquipment: {
      const { routeId, isDragging } = action.payload;

      return setIsDragging(state, {
        isDragging,
        type: 'equipment',
        routeId
      });
    }
    default:
      return state;
  }
}
